import './App.css';
import {RouterProvider} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import AuthProvider from "./store/AuthProvider";
import router from "./config/routes";
import customTheme from "./config/customTheme";
import {useEffect} from "react";
import {Events, scrollSpy} from "react-scroll";
import LanguageProvider from "./store/LanguageProvider";

/*
    TODO:
        [x] Google search console
        [ ] Leggera ottimizzazione seo
        [x] Animazione contatti
        [x] Pagina errore
        [x] Pulsante Admin se si è loggati
        [ ] Sistemare admin su mobile
        [ ] A volte non carica la lista categorie o la lista allergeni
        [x] Inserire lista allergeni
        [ ] Pagina qr code
 */

function App() {
    useEffect(() => {
        if (!localStorage.getItem('lang')){
            const lang = navigator.language.split('-')[0];
            localStorage.setItem('lang', lang);
        }

        // Registering the 'begin' event and logging it to the console when triggered.
        Events.scrollEvent.register('begin', (to, element) => {
        });

        // Registering the 'end' event and logging it to the console when triggered.
        Events.scrollEvent.register('end', (to, element) => {
        });

        // Updating scrollSpy when the component mounts.
        scrollSpy.update();

        // Returning a cleanup function to remove the registered events when the component unmounts.
        return () => {
            Events.scrollEvent.remove('begin');
            Events.scrollEvent.remove('end');
        };
    }, []);

    return (
        <ThemeProvider theme={customTheme}>
            <AuthProvider>
                <LanguageProvider>
                    <RouterProvider router={router}></RouterProvider>
                </LanguageProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
